import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import vqTabs from './components/vqTabs.vue'
import vqAccordion from './components/vqAccordion'
import vqLoadmore from './components/vqLoadmore.vue'
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'core-js/stable'; 
import 'regenerator-runtime/runtime';

import '../style/style.css'

const requireComponent = require.context(
  // Le chemin relatif du dossier composants
  './components',
  // Suivre ou non les sous-dossiers
  true,
  // L'expression régulière utilisée pour faire concorder les noms de fichiers de composant de base
  /[A-Za-z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  // Récupérer la configuration du composant
  const componentConfig = requireComponent(fileName)

  // Récupérer le nom du composant en PascalCase
  const componentName = upperFirst(
    camelCase(
      // Retrouver le nom du fichier indépendemment de la profondeur de dossier
      fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')
    )
  )

    // Créer un composant global
  Vue.component(
    componentName,
    // Chercher les options du composant dans `.default`, qui
    // existera si le composant a été exporté avec `export default`,
    // sinon revenez à la racine du module.
    componentConfig.default || componentConfig
  )
})
Vue.component("vqMap",require("./components/vqMap.vue").default);

document
  .querySelectorAll('.vq-component')
  .forEach((el) => {
    new Vue({
      delimiters: ["[[", "]]"],
      el,
      components: {
        vqAccordion,
        vqTabs,
        vqLoadmore
      }
    })
  })

AOS.init({
  duration: 1000,
  once: true
})

require("./apps/partners");
require("./apps/formations");
require('./apps/header')
require("./apps/carousel-home");
require("./apps/slider-testimonial");
require("./apps/slider-staff");
require("./apps/slider-brakes");
require("./apps/news");
require("./apps/solutions");
require("./apps/newsletter");

require("./js/video-placeholder");
require("./js/animations");


